module.exports = __webpack_public_path__ + "img/161.5b74aad1.jpeg";